export const GET_VEHICLES_REQUEST = "GET_VEHICLES_REQUEST";
export const GET_VEHICLES_SUCCESS = "GET_VEHICLES_SUCCESS";
export const GET_VEHICLES_FAILURE = "GET_VEHICLES_FAILURE";

export const GET_VEHICLE_REQUEST = "GET_VEHICLE_REQUEST";
export const GET_VEHICLE_SUCCESS = "GET_VEHICLE_SUCCESS";
export const GET_VEHICLE_FAILURE = "GET_VEHICLE_FAILURE";

export const GET_VEHICLES_STATUSES_REQUEST = "GET_VEHICLES_STATUSES_REQUEST";
export const GET_VEHICLES_STATUSES_SUCCESS = "GET_VEHICLES_STATUSES_SUCCESS";
export const GET_VEHICLES_STATUSES_FAILURE = "GET_VEHICLES_STATUSES_FAILURE";

export const GET_VEHICLE_AUDIT_REQUEST = "GET_VEHICLE_AUDIT_REQUEST";
export const GET_VEHICLE_AUDIT_SUCCESS = "GET_VEHICLE_AUDIT_SUCCESS";
export const GET_VEHICLE_AUDIT_FAILURE = "GET_VEHICLE_AUDIT_FAILURE";

export const GET_VEHICLE_TICKETS_REQUEST = "GET_VEHICLE_TICKETS_REQUEST";
export const GET_VEHICLE_TICKETS_SUCCESS = "GET_VEHICLE_TICKETS_SUCCESS";
export const GET_VEHICLE_TICKETS_FAILURE = "GET_VEHICLE_TICKETS_FAILURE";

export const PATCH_VEHICLE_REQUEST = "PATCH_VEHICLE_REQUEST";
export const PATCH_VEHICLE_SUCCESS = "PATCH_VEHICLE_SUCCESS";
export const PATCH_VEHICLE_FAILURE = "PATCH_VEHICLE_FAILURE";

export const ASSIGN_VEHICLE_AGENT_REQUEST = "ASSIGN_VEHICLE_AGENT_REQUEST";
export const ASSIGN_VEHICLE_AGENT_SUCCESS = "ASSIGN_VEHICLE_AGENT_SUCCESS";
export const ASSIGN_VEHICLE_AGENT_FAILURE = "ASSIGN_VEHICLE_AGENT_FAILURE";

export const ADD_VEHICLE_COMMENT_REQUEST = "ADD_VEHICLE_COMMENT_REQUEST";
export const ADD_VEHICLE_COMMENT_SUCCESS = "ADD_VEHICLE_COMMENT_SUCCESS";
export const ADD_VEHICLE_COMMENT_FAILURE = "ADD_VEHICLE_COMMENT_FAILURE";

export const SET_VEHICLES = "SET_VEHICLES";

export const getVehiclesRequest = (filters = {}) => ({
    type: GET_VEHICLES_REQUEST,
    payload: {
        filters,
        page: filters.page || 1  
    }
});

export const getVehiclesSuccess = (vehicles, total, page = 1, filters = {}) => ({
    type: GET_VEHICLES_SUCCESS,
    payload: {
        vehicles,
        total,
        page,   
        filters  
    }
});

export const getVehiclesFailure = err => ({
    type: GET_VEHICLES_FAILURE,
    error: err
});

export const getVehicleRequest = (filters = {}) => ({
    type: GET_VEHICLE_REQUEST,
    payload: {
        filters
    }
});

export const getVehicleSuccess = vehicle => ({
    type: GET_VEHICLE_SUCCESS,
    payload: {
        vehicle
    }
});

export const getVehicleFailure = err => ({
    type: GET_VEHICLE_FAILURE,
    error: err
});

export const setVehicle = (vehicle = {}) => ({
    type: SET_VEHICLES,
    payload: {
        vehicle
    }
});


export const getVehicleAuditRequest = (vehicleId) => ({
    type: GET_VEHICLE_AUDIT_REQUEST,
    payload: { vehicleId }
  });
  
  export const getVehicleAuditSuccess = (audits, pagination) => ({
    type: GET_VEHICLE_AUDIT_SUCCESS,
    payload: { audits, pagination }
  });
  
  export const getVehicleAuditFailure = (error) => ({
    type: GET_VEHICLE_AUDIT_FAILURE,
    payload: { error }
  });

  export const getVehicleTicketsRequest = (vehicleId) => ({
    type: GET_VEHICLE_TICKETS_REQUEST,
    payload: { vehicleId }
  });
  
  export const getVehicleTicketsSuccess = (tickets, pagination) => ({
    type: GET_VEHICLE_TICKETS_SUCCESS,
    payload: { tickets, pagination }
  });
  
  export const getVehicleTicketsFailure = (error) => ({
    type: GET_VEHICLE_TICKETS_FAILURE,
    payload: { error }
  });

  export const patchVehicleRequest = (vehicleId, data) => ({
    type: PATCH_VEHICLE_REQUEST,
    payload: { vehicleId, data }
  });
  
  export const patchVehicleSuccess = (vehicle) => ({
    type: PATCH_VEHICLE_SUCCESS,
    payload: vehicle
  });
  
  export const patchVehicleFailure = (error) => ({
    type: PATCH_VEHICLE_FAILURE,
    payload: error
  });

  export const assignVehicleAgentRequest = (vehicleId, agentId) => ({
    type: ASSIGN_VEHICLE_AGENT_REQUEST,
    payload: { vehicleId, agentId }
  });

  export const assignVehicleAgentSuccess = (vehicle) => ({
    type: ASSIGN_VEHICLE_AGENT_SUCCESS,
    payload: { vehicle }
  });

  export const assignVehicleAgentFailure = (error) => ({
    type: ASSIGN_VEHICLE_AGENT_FAILURE,
    payload: { error }
  });

export const addVehicleCommentRequest = (vehicleId, comments) => ({
    type: ADD_VEHICLE_COMMENT_REQUEST,
    payload: { vehicleId, comments }
});

export const addVehicleCommentSuccess = (data) => ({
    type: ADD_VEHICLE_COMMENT_SUCCESS,
    payload: { data }
});

export const addVehicleCommentFailure = (error) => ({
    type: ADD_VEHICLE_COMMENT_FAILURE,
    payload: { error }
});